import React, { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

const TwoColumnGrid: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      columnGap: 1.5,
    }}
  >
    {children}
  </Box>
);

export default TwoColumnGrid;
